<template>
    <div class="mbsut">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="title">Мэргэжлийн боловсрол, сургалтын үнэлгээ, мэдээлэл, аргазүйн төв</h3>
                </div>
            </div>
            <div class="mbsut_main">
                <div class="row">
                    <div class="col-md-4">
                        <img src="../assets/zahiral.svg" alt="" class="image">
                    </div>
                    <div class="col-md-8">
                        <div class="mbsut_text">
                            <Tabs size="small">
                                <TabPane label="ЗОРИЛГО, ЗОРИЛТ">
                                    <div class="tab">
                                        <p v-html="about.zorilgo_zorilt"></p>
                                    </div>
                                </TabPane>
                                <TabPane label="БИДНИЙ ТУХАЙ">
                                    <div class="tab">
                                        <p v-html="about.bidnii_tuhai"></p>
                                    </div>
                                </TabPane>
                                <TabPane label="ЗАХИРЛЫН МЭНДЧИЛГЭЭ">
                                    <div class="tab">
                                        <p v-html="about.zahiral_mend"></p>
<!--                                        <div class="name">Хүндэтгэсэн, <h3>Ц. Батдорж</h3></div>-->
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mbsut_turul">
                 <div class="row">
                     <div class="col-md-4" :key="index" v-for="(serve, index) in service">
                         <div class="mbsut_turul_item">
                             <h3>{{serve.title}}</h3>
                             <p v-html="serve.description"></p>
                         </div>
                     </div>
                 </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="butets">
                          <div class="butets_title">МБС-ын үнэлгээ, мэдээлэл, арга зүйн төвийн бүтэц</div>
                          <img :src="about.zurag" alt="">
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {getMBSUTabout} from "../api/index"
    export default {
        data () {
            return {
                about: {},
                service: []
            }
        },
        mounted () {
            this.calldata();
        },
        methods: {
            calldata(){
                this.$isLoading(true);
                getMBSUTabout().then(response=>{
                    this.about = response.data.data;
                    this.service = response.data.service;
                    console.log(response.data);

                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
            changePageTusgai(page) {
                this.current_page = page;
                this.calldata();
            },
        },
    }
</script>
